module.exports = __webpack_public_path__ + "static/media/Weather _ Climate Information Assistance.17c18aa1.png";